<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <p class="text-xs-center subheading">
          {{ $t('message.instructions.storeLocations') }}
        </p>
      </v-flex>
      <v-layout row wrap class="btn-wrapper">
        <v-dialog
          v-model="dialog"
          @keydown.esc="dialog = false"
          persistent
          max-width="500px"
        >
          <v-btn
            v-show="this.$store.getters.getLocations.length != 0"
            slot="activator"
            class="btn-primary"
          >
            <img src="static/icons/add_white.png" width="24" />
            {{ $t('message.locationLabel') }}
          </v-btn>
          <v-form
            ref="locationForm"
            v-model="valid"
            @keydown="errors.clear($event.target.name)"
          >
            <v-card>
              <v-flex
                xs24
                sm12
                v-show="loading"
                class="grey"
                style="opacity:50%;position: absolute;width: 100%;height: 100%;"
              >
                <v-progress-circular
                  style="width: 100%;"
                  :size="70"
                  :width="8"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-flex>
              <v-card-title>
                <span v-if="locationIndex == -1" class="headline">{{
                  $t('message.newLocation')
                }}</span>
                <span v-else class="headline">{{
                  $t('message.updateLocation')
                }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md class="no-top-padding">
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="location.name"
                        :label="$t('message.location.name')"
                        :rules="nameRules"
                        validate-on-blur
                        required
                        maxlength="30"
                        :counter="30"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="location.addressStreet"
                        :label="$t('message.streetAddress')"
                        :rules="addressRules"
                        validate-on-blur
                        required
                        maxlength="30"
                        :counter="30"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="location.addressCity"
                        :label="$t('message.city')"
                        :rules="cityRules"
                        validate-on-blur
                        required
                        maxlength="20"
                        :counter="20"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <v-text-field
                        v-model="location.addressState"
                        :rules="stateRules"
                        :mask="stateMask"
                        :label="$t('message.state')"
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <v-text-field
                        v-model="location.addressZipCode"
                        :rules="zipCodeRules"
                        :mask="zipMask"
                        :label="$t('message.zipCode')"
                        type="tel"
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="location.contactName"
                        :label="$t('message.location.contactName')"
                        :rules="contactNameRules"
                        validate-on-blur
                        required
                        maxlength="30"
                        :counter="30"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="location.phoneNumber"
                        :label="$t('message.phoneNumber')"
                        type="tel"
                        :rules="phoneRules"
                        :mask="phoneMask"
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="location.faxNumber"
                        :label="$t('message.faxNumber')"
                        :rules="phoneOptionalRules"
                        type="tel"
                        :mask="phoneMask"
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="location.emailAddress"
                        :label="$t('message.email')"
                        :rules="emailRules"
                        type="email"
                        validate-on-blur
                        required
                        maxlength="60"
                        :counter="60"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat class="btn-secondary" @click.native="close">{{
                  $t('message.cancel')
                }}</v-btn>
                <v-btn
                  flat
                  class="btn-primary"
                  v-show="this.locationIndex == -1"
                  @click="saveLocation"
                  :disabled="saveDisabled"
                  >{{ $t('message.add') }}
                </v-btn>

                <v-tooltip top>
                  <v-btn
                    flat
                    slot="activator"
                    class="btn-primary"
                    v-show="this.locationIndex != -1"
                    @click="saveLocation"
                    :disabled="saveDisabled"
                  >
                    {{ $t('message.save') }}
                  </v-btn>
                  <span> {{ $t('message.saveAndResume') }}</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog
          v-model="importDialog"
          @keydown.esc="importDialog = false"
          persistent
          max-width="500px"
        >
          <v-btn
            v-show="this.$store.getters.getLocations.length != 0"
            slot="activator"
            class="btn-primary"
          >
            <img src="static/icons/unarchive_white.png" width="24" />
            {{ $t('message.import.label') }}
          </v-btn>

          <v-form ref="importForm" @keydown="errors.clear($event.target.name)">
            <v-card>
              <v-flex
                xs24
                sm12
                v-show="loading"
                class="grey"
                style="opacity:50%;position: absolute;width: 100%;height: 100%;"
              >
                <v-progress-circular
                  style="width: 100%;"
                  :size="70"
                  :width="8"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-flex>
              <v-card-title>
                <span class="headline">{{
                  $t('message.import.locations')
                }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md class="no-top-padding">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <ol class="import-directions">
                        <li>
                          {{ $t('message.import.step1') }}
                          <v-tooltip bottom class="icon-link">
                            <v-btn
                              slot="activator"
                              icon
                              @click="downloadTemplate()"
                            >
                              <img
                                src="static/icons/cloud_download_blue.png"
                                width="44"
                                style="cursor: pointer;"
                              />
                            </v-btn>
                            <span>{{ $t('message.download') }}</span>
                          </v-tooltip>
                        </li>
                        <li>
                          {{ $t('message.import.step2') }}
                        </li>
                        <li>
                          {{ $t('message.import.step3') }}
                          <v-tooltip bottom class="icon-link">
                            <label for="locationFile" slot="activator">
                              <img
                                src="static/icons/cloud_upload_blue.png"
                                width="44"
                                style="cursor: pointer;"
                              />
                            </label>
                            <input
                              type="file"
                              id="locationFile"
                              :accept="fileUploadValidTypes"
                              ref="locationFile"
                              v-on:change="handleFileUpload()"
                            />
                            <span>{{ $t('message.upload') }}</span>
                          </v-tooltip>
                        </li>
                      </ol>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  class="btn-secondary"
                  @click.native="importDialog = false"
                  >{{ $t('message.cancel') }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-layout>
      <v-container
        grid-list-md
        v-if="this.$store.getters.getLocations.length > 0"
      >
        <v-data-table
          :headers="headers"
          :items="this.$store.getters.getLocations"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td class="hidden-sm-and-down">{{ props.item.addressStreet }}</td>
            <td>{{ props.item.addressCity }}</td>
            <td class="hidden-xs-and-down">{{ props.item.addressState }}</td>
            <td class="hidden-sm-and-down">{{ props.item.addressZipCode }}</td>
            <td class="hidden-sm-and-down">
              {{ props.item.phoneNumber | phoneFilter }}
            </td>
            <td class="text-xs-right">
              <v-tooltip bottom>
                <v-btn slot="activator" icon @click="edit(props.item)">
                  <img src="static/icons/create_gray.png" width="26" />
                </v-btn>
                <span>{{ $t('message.edit') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  @click="remove(props.item)"
                  icon
                  class="grey--text"
                >
                  <img src="static/icons/delete_gray.png" width="26" />
                </v-btn>
                <span>{{ $t('message.remove') }}</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-container>
      <empty-list
        v-if="this.$store.getters.getLocations.length == 0"
        v-bind:message="$t('message.locationLabel')"
        v-bind:import="true"
        @clicked="dialog = true"
        @importClicked="importDialog = true"
      ></empty-list>
    </v-layout>
  </v-container>
</template>

<script>
import { axiosAuthInstance } from '../../main.js'
import EmptyList from '../util/EmptyList'

export default {
  data() {
    return {
      fileUploadValidTypes: ".csv,text/csv",
      headers: [
        { text: 'Name', align: 'left', value: 'name', sortable: false },
        {
          text: 'Street Address',
          value: 'addressStreet',
          class: 'hidden-sm-and-down',
          sortable: false
        },
        { text: 'City', value: 'addressCity', sortable: false },
        {
          text: 'State',
          value: 'addressState',
          class: 'hidden-xs-and-down',
          sortable: false
        },
        {
          text: 'Zip Code',
          value: 'addressZipCode',
          class: 'hidden-sm-and-down',
          sortable: false
        },
        {
          text: 'Phone',
          value: 'phoneNumber',
          class: 'hidden-sm-and-down',
          sortable: false
        },
        { value: '', sortable: false }
      ],
      location: {
        id: '',
        applicationId: '',
        name: this.$store.state.dealerApplication.doingBusinessAs,
        addressStreet: '',
        addressCity: '',
        addressState: '',
        addressZipCode: '',
        contactName: '',
        phoneNumber: '',
        faxNumber: '',
        emailAddress: ''
      },
      nameRules: [v => !!v || 'Name/DBA Name is required'],
      showLocationForm: false,
      saveDisabled: false,
      loading: false,
      dialog: false,
      importDialog: false,
      valid: true,
      locationIndex: -1
    }
  },
  methods: {
    saveLocation() {
      if (this.checkAndConfirmInvalidate() && this.$refs.locationForm.validate()) {
        this.saveDisabled = true
        this.loading = true
        var tempLocation = Object.assign({}, this.location)
        tempLocation.applicationId = this.$store.getters.getApplicationId
        var serviceMethod = this.locationIndex > -1 ? 'update' : 'create'
        axiosAuthInstance
          .post('api/v1/location/' + serviceMethod, tempLocation)
          .then(response => {
            if (this.locationIndex > -1) {
              this.$store.getters.getLocations[
                this.locationIndex
              ] = Object.assign(
                this.$store.getters.getLocations[this.locationIndex],
                tempLocation
              )
            } else {
              tempLocation = response.data
              this.$store.getters.getLocations.push(tempLocation)
            }
            this.close()

            this.notifyInfo('Location saved')
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error saving the location'
            )
          })
          .then(() => {
            if (this.$store.getters.isApplicationJustInvalidated) {
              this.$store.commit('setApplicationJustInvalidated', false)
              this.$router.go() //reload to pick up all server side changes
            } else {
              this.loading = false
              this.saveDisabled = false
            }
          })
      }
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.$refs.locationForm.reset()
        this.locationIndex = -1
        this.saveDisabled = false
        this.loading = false
      }, 200)
    },
    edit(inLocation) {
      this.locationIndex = this.$store.getters.getLocations.indexOf(inLocation)
      this.location = Object.assign({}, inLocation)
      this.dialog = true
    },
    remove(inLocation) {
      if (confirm('Are you sure you want to remove this location?')) {
        axiosAuthInstance
          .delete('api/v1/location/', { data: inLocation })
          .then(response => {
            const index = this.$store.getters.getLocations.indexOf(inLocation)
            this.$store.getters.getLocations.splice(index, 1)
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error deleting the location'
            )
          })
      }
    },
    downloadTemplate() {
      axiosAuthInstance
        .get('api/v1/location/import/template')
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'location_import_template.csv')
          document.body.appendChild(link)
          link.click()
        })
    },
    handleFileUpload() {
      if (this.checkAndConfirmInvalidate()) {
        const locationFile = this.$refs.locationFile.files[0]

        //todo: why is this called sometimes when the file dlg is canceled?
        if (locationFile) {
          this.loading = true
          var fileFormData = new FormData()
          fileFormData.append('file', locationFile)

          axiosAuthInstance
            .post(
              'api/v1/location/import/' + this.$store.getters.getApplicationId,
              fileFormData,
              {headers: {'Content-Type': 'multipart/form-data'}}
            )
            .then(response => {
              this.notifyInfo('Locations imported')
              axiosAuthInstance
                .get(
                  'api/v1/location/application/' +
                  this.$store.getters.getApplicationId
                )
                .then(response => {
                  if (response.data && response.data.length > 0) {
                    this.$store.commit('setLocations', response.data)
                  }
                })
                .catch(error => {
                  console.log('error response: ' + error)
                })
                .then(() => {
                  if (this.$store.getters.isApplicationJustInvalidated) {
                    this.$store.commit('setApplicationJustInvalidated', false)
                    this.$router.go() //reload to pick up all server side changes
                  } else {
                    this.$refs.importForm.reset()
                    this.importDialog = false
                  }
                })
            })
            .catch(error => {
              this.notifyError(error.response.data.errorMessage)
            })
            .then(() => {
              this.loading = false
            })
        }
      }
    }
  },
  mounted() {
    axiosAuthInstance
      .get(
        'api/v1/location/application/' + this.$store.getters.getApplicationId
      )
      .then(response => {
        if (response.data && response.data.length > 0) {
          this.$store.commit('setLocations', response.data)
        }
      })
      .catch(error => {
        console.log('error response: ' + error)
      })
  },
  components: {
    'empty-list': EmptyList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Application/StoreLocations.vue